var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPendingReviewL(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPendingReviewL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPendingReviewL"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FC8106",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8593259,10.8305463 C26.3586468,10.8305463 27.6272761,11.625896 27.6272761,13.0356255 C27.6272761,17.3372675 27.0890732,23.5188767 27.0890732,27.8205188 C27.0890732,28.9411991 25.7819759,29.4109996 24.8593259,29.4109996 C23.6292807,29.4109996 22.5912267,28.9410898 22.5912267,27.8205188 C22.5912267,23.5188767 22.0531401,17.3372675 22.0531401,13.0356255 C22.0531401,11.625896 23.2831852,10.8305463 24.8593259,10.8305463 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8584357,36.843181 C23.2555041,36.843181 22.0531401,35.5401419 22.0531401,34.056113 C22.0531401,32.5358642 23.2553939,31.269045 24.8584357,31.269045 C26.3521117,31.269045 27.6272761,32.5358642 27.6272761,34.056113 C27.6272761,35.5401419 26.3521117,36.843181 24.8584357,36.843181 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingReviewL);
export default __webpack_public_path__ + "static/media/icPendingReviewL.f42ef152d71147a4d78d83e0e98d171c.svg";
export { ForwardRef as ReactComponent };